import isObject      from 'lodash/isObject';
import merge        from 'lodash/merge';
import reduce        from 'lodash/reduce';

export const flattenKeys = (obj, path = []) => (
  !isObject(obj)
    ? { [path.join('.')]: obj }
    : reduce(obj, (cum, next, key) => merge(cum, flattenKeys(next, [...path, key])), {})
);
